import { MAPS_API_KEY } from 'constants/googleMaps';
import isEmpty from 'lodash/isEmpty';
import { FC, useEffect, useState } from 'react';
import { Chart } from 'react-google-charts';
import { NoResult } from 'ui/illustrations';
import { BasicSelect } from 'ui/selects';
import { Skeleton } from 'ui/skeleton';
import { SelectWrapper } from '../Styled';
import { mapRegions } from '../constants';
import { useTabSpecificFiltersContext } from '../context';
import { useRestData } from '../hooks/useRestData';
import { RestDataIdentifier } from '../types';
import { NoDataMessage } from './NoDataMessage';

export const Location: FC<React.PropsWithChildren<unknown>> = () => {
  const {
    data: locationData,
    loading,
    error: showErrorState,
  } = useRestData(RestDataIdentifier.LOCATION);
  const headerRow: [string, string | number][] = [['City', 'Activity']];
  const [data, setData] = useState(headerRow);
  const { region, setRegion } = useTabSpecificFiltersContext();

  const updateGeoMap = () => {
    if (!isEmpty(locationData)) {
      const cityData = locationData?.value || {};
      const formattedData: [string, number][] = Object.entries(cityData);
      setData(headerRow.concat(formattedData));
    }
  };

  useEffect(() => {
    updateGeoMap();
  }, [locationData]);

  return (
    <>
      {!showErrorState && !loading && (
        <div>
          <SelectWrapper>
            <BasicSelect
              onSelect={setRegion}
              defaultValues={region}
              placeholder="Select a location..."
              id="location-region"
              options={mapRegions}
              title="location"
            />
          </SelectWrapper>
          <Chart
            width="100%"
            height="auto"
            chartType="GeoChart"
            data={data}
            options={{
              region: region[0],
              displayMode: 'markers',
              colors: ['#3498db', '#e74c3c'],
            }}
            loader={<Skeleton height={920} />}
            // Note: you will need to get a mapsApiKey for your project.
            // See: https={//developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
            mapsApiKey={MAPS_API_KEY}
          />
        </div>
      )}
      {!showErrorState && loading && <Skeleton height={1000} />}
      {showErrorState && !loading && (
        <NoDataMessage
          Icon={NoResult}
          title="Sorry we couldn't load this page"
          subtitle="Try refreshing the page. If this keeps happening, let us know."
        />
      )}
    </>
  );
};
